export default __webpack_public_path__ + "static/artifakt-legend-medium-afcb2741af00fddbcce424db24fea6b2.eot";